/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S4_P2_AfterInputs */

const tr_hakkimizda_s4_p2_after = /** @type {(inputs: Hakkimizda_S4_P2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` sayfamızı inceleyebilirsiniz.`)
};

const en_hakkimizda_s4_p2_after = /** @type {(inputs: Hakkimizda_S4_P2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` page.`)
};

const de_hakkimizda_s4_p2_after = /** @type {(inputs: Hakkimizda_S4_P2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const ru_hakkimizda_s4_p2_after = /** @type {(inputs: Hakkimizda_S4_P2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "page." |
*
* @param {Hakkimizda_S4_P2_AfterInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s4_p2_after = /** @type {((inputs?: Hakkimizda_S4_P2_AfterInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S4_P2_AfterInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s4_p2_after(inputs)
	if (locale === "de") return de_hakkimizda_s4_p2_after(inputs)
	if (locale === "ru") return ru_hakkimizda_s4_p2_after(inputs)
	return tr_hakkimizda_s4_p2_after(inputs)
});